const translationContext = "clients.form.enum";
export const GM = { value: 1, key: `${translationContext}.gm`, acronym: "GM" };
export const PM = {
  value: 2,
  key: `${translationContext}.pm`,
  acronym: "PM"
};

export default [GM, PM];


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/businessAccountTypes.js